import { render, staticRenderFns } from "./InputSelectStock.vue?vue&type=template&id=b4cf725c&scoped=true"
import script from "./InputSelectStock.vue?vue&type=script&lang=js"
export * from "./InputSelectStock.vue?vue&type=script&lang=js"
import style0 from "./InputSelectStock.vue?vue&type=style&index=0&id=b4cf725c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cf725c",
  null
  
)

export default component.exports